import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall, getStatus } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
class StatuDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: [],
      formData: {
        name: ''
      },
      loading: false,
      isLoad: true,
    }
  }
  componentDidMount() {
    this.getStatuInfo();
  }
  setStatus = async () => {
    const status = await getStatus();
    localStorage.setItem('status', JSON.stringify(status));
  }
  getStatuInfo = async () => {
    const { id } = this.props.match.params;
    try {
      const response = await apiCall('business/operation/status/info/' + id, 'get', null);
      this.setState({ status: response });
      const updatedData = { ...this.state.formData };
      Object.keys(updatedData).forEach(key => {
        updatedData[key] = response[key] === undefined ? "" : response[key]
      })
      this.setState({ formData: updatedData, isLoad: false }, () => { });
    } catch (e) {
      this.setState({ isLoad: false });
    }
  }
  handleChance = (e) => {
    const { id, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [id]: value
      }
    }))
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const { id } = this.props.match.params;
    const { formData } = this.state;
    const statuFormData = new FormData();
    Object.keys(formData).forEach(key => {
      statuFormData.append(key, formData[key]);
    });
    try {
      const response = await apiCall('business/operation/status/update/' + id, 'post', statuFormData);
      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState({ loading: false });
    }

  }
  render() {
    const { formData, loading } = this.state;
    const { userPermissions } = this.props;
    const userHasUpdateStatusPermission = userPermissions.includes('update setting service status');
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Servis Durum Detayı"
              Breadcrumb={[
                { name: "Servis Durumları", navigate: "status" },
                { name: "Detay", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <form onSubmit={this.handleSubmit}>
                    <div className="body">
                      <div className="row clearfix justify-content-center">
                        <div className="col-lg-6 col-md-12">
                          <label htmlFor="name" className="font-weight-bold text-cyan">Servis Durum Adı</label>
                          <div className="form-group">
                            <input
                              id="name"
                              className="form-control"
                              placeholder="Servis Durum Adı"
                              type="text"
                              value={formData.name || ''}
                              onChange={this.handleChance}
                            />
                          </div>

                        </div>
                      </div>

                    </div>
                    <div className="body">
                      <div className="row clearfix justify-content-center">
                        <div className="col-lg-6 col-md-12">
                          {loading ? (
                            <button className="btn btn-outline-primary btn-block"
                              disabled={true}
                              style={{ textAlign: "-webkit-center" }}>
                              Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                height={'24px'}
                                color="#268bd2"></ReactLoading>
                            </button>
                          ) :
                            <button disabled={!userHasUpdateStatusPermission}
                              className="btn btn-outline-primary btn-block"
                              type="submit">
                              Güncelle
                            </button>}

                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(StatuDetail)));
